/**
 * Icons Module
 * Minimal icon set for template-project
 */

import * as PDP from './PDP';
import * as Stars from './Stars';

// Re-export individual star components for direct import
export { Star, StarEmpty, StarHalf } from './Stars';

export const Icon = {
  PDP,
  Stars,
};

export type { IconProps } from './PDP';
export { PDP, Stars };

// Default export for easier imports
export default Icon;

